import { useQuery } from '@tanstack/react-query';
import { QUERY_SESSION_NOTES_KEY } from '@web-app/hooks/consts';
import { Task } from '@web-app/server/api/types';

const getReadyTasks = async (): Promise<Task[]> => {
  try {
    const response = await fetch('/api/session-notes/tasks?status=ready');

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  } catch (err) {
    console.error('Error getting tasks', err);
    return [];
  }
};

const getReviewedTasks = async (
  page: number,
): Promise<{ data: Task[]; hasNextPage: boolean }> => {
  try {
    const response = await fetch(
      `/api/session-notes/tasks?page=${page}&status=reviewed`,
    );

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  } catch (err) {
    console.error('Error getting reviewed tasks', err);
    return {
      data: [],
      hasNextPage: false,
    };
  }
};

export const useReadyTasks = () => {
  return useQuery({
    queryKey: [QUERY_SESSION_NOTES_KEY],
    queryFn: () => getReadyTasks(),
    refetchInterval: 5000,
  });
};

export const useReviewedTasks = (page: number) => {
  return useQuery({
    queryKey: [QUERY_SESSION_NOTES_KEY, page],
    queryFn: () => getReviewedTasks(page),
    placeholderData: (previousData) => previousData,
  });
};
